import { wrap } from '@/utils/endpoints';

const ENDPOINTS = wrap('', {
  auth: {
    index: '',
    refresh: '/refresh',
  },
  taxPayers: {
    index: '',
    id: (id) => `/${id}`,
    idDetailsYear: ({ id, year }) => `/${id}/details/${year}`,
    idDetailsIncomeYear: (id) => `/${id}/details/income`,
    idTaxDetails: (id) => `/${id}/tax/details`,
    idTaxHistory: (id) => `/${id}/tax/history`,
  },
  partners: {
    index: '',
    idDetailsYear: ({ id, year }) => `/${id}/details/${year}`,
    idDetailsIncomeYear: (id) => `/${id}/details/income`,
    all: '/all',
  },
  receipts: {
    id: (id) => `/${id}`,
    income: {
      id: (id) => `/${id}`,
    },
    tax: {
      id: (id) => `/${id}`,
    },
  },
  users: {
    index: '',
  },
  locale: {
    index: '',
  },
  taxModes: '/taxModes',
  summary: '/summary',
});

export default ENDPOINTS;
